/**
 * @description SubDomain enum
 */
export enum SubDomain {

	/**
	 * @description player-services
	 * @type {string}
	 */
	PLAYER_SERVICES = 'player-services',

}